var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"noReply"}},[_c('div',{staticClass:"noReplyTopics"},_vm._l((_vm.noReplyTopics),function(topic){return _c('p',{key:topic.id},[_vm._v("\n        "+_vm._s(_vm.ellipsis(topic.title, 21))+"\n      ")])}),0),_vm._v(" "),_c('p',{staticClass:"describe"},[_vm._v("无人回复的话题")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30a4a56e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Noreply.vue
// module id = null
// module chunks = 